import { Component, DestroyRef, inject, ChangeDetectionStrategy } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { IdleTimeoutService } from '../core/services/idle-timeout/idle-timeout.service';

@Component({
  selector: 'app-idle-warning-dialog',
  imports: [MatButtonModule, MatDialogModule, MatIconModule],
  templateUrl: './idle-warning-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './idle-warning-dialog.component.scss',
})
export class IdleWarningDialogComponent {
  private idleTimeoutService = inject(IdleTimeoutService);
  private dialogRef = inject(MatDialogRef<IdleWarningDialogComponent>);
  private destroyRef = inject(DestroyRef);

  timer: string | null = null;

  constructor() {
    this.idleTimeoutService.logoutCountdown$
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((countdown) => {
        const minutes = Math.floor(countdown / 60);
        let seconds = Math.floor(countdown % 60).toString();
        seconds = seconds.length > 1 ? seconds : 0 + seconds;
        this.timer = minutes + ':' + seconds;
      });
  }

  close() {
    this.dialogRef.close(true);
  }
}
